import {
  DndContext,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EditCardModal from './CardEditModal';
import SortableConnectCard from './SortableConnectCard';

const SortableConnectCards = ({
  cards,
  onSort,
  onUpdateConnectCard,
  onDelete,
}) => {
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));
  const [selected, setSelected] = useState(null);
  const [t] = useTranslation('groups');

  const onSave = async (values) => {
    await onUpdateConnectCard(values);
    setSelected(null);
  };

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = cards.findIndex((q) => q.id === active.id);
      const newIndex = cards.findIndex((q) => q.id === over.id);
      onSort(cards, oldIndex, newIndex);
    }
  }

  return (
    <Box>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
        autoScroll
      >
        <SortableContext items={cards || []} strategy={rectSortingStrategy}>
          {cards.map((card, idx) => (
            <SortableConnectCard
              key={card.id}
              index={idx}
              data={card}
              onEdit={setSelected}
              onDelete={onDelete}
            />
          ))}
        </SortableContext>
      </DndContext>
      {selected && (
        <EditCardModal
          card={selected}
          onSave={onSave}
          onCancel={() => setSelected(null)}
        />
      )}
    </Box>
  );
};

export default SortableConnectCards;
